import { all } from 'redux-saga/effects';
import { watchProductRequests } from '../integrations/woocommerce/productSaga';
import { watchAuthActions } from './auth';
import { watchWishlistActions } from './wishlist';
import { watchReviewActions } from './reviews';
import { watchCheckoutActions } from './checkout';

export default function* rootSaga() {
  yield all([watchProductRequests(), watchAuthActions(), watchWishlistActions(), watchReviewActions(), watchCheckoutActions()]);
}
